/* global ROOT */
export default {
    namespaced: true,
    state: () => ({
        data: {}, // see bridge._fetchCache()
        internetOptions: { // All the current Internet selections made in the buyflow
            service: { // The Internet service selection (Base Internet, Unlimited UltraFast, ...)
                decision: null,
                selection: null,
            },
            modem: { // The Internet modem selection (Gateway Lease, Gateway Lease - Discounted, Customer Owned Modem)
                decision: null,
                selection: null,
            },
            equipment: { // The Internet equipment selection (WiFi Your Way, WiFi Your Way - 1 Pod, ...) or null
                decision: null,
                selection: null,
            },
            pods: { // The Internet extra pods selection and number of pods selected or 0
                decision: null,
                selection: null,
                quantity: 0,
            },
        },
    }),

    getters: {
        selectedService (state) {
            // returns the selected service or null
            return state.internetOptions.service.selection
        },
        getServicePrice: (state, getters) => (service, addOtherServices = false) => {
            // if service.credit returns any faulty value then return 0
            let serviceCredit = service.credit || 0
            // returns the computed price of the service, the $10 credit comes from AutoPay
            let res = service.promoPrice - 10 + serviceCredit
            if (addOtherServices) {
                const otherServices = getters.otherServices
                res += otherServices.tv ? otherServices.tv.price : 0
                res += otherServices.voice ? otherServices.voice.price : 0
            }
            return res
        },
        selectedEquipment (state) {
            // returns the selected equipment or null
            return state.internetOptions.equipment.selection ?? state.internetOptions.modem.selection
        },
        isEquipmentSelected: (state, getters) => equipment => {
            // returns true if the equipment is selected, otherwise false
            return equipment.name === getters.selectedEquipment?.name
        },
        podOrExtender: (state, getters) => {
            // returns true if the equipment is selected, otherwise false
            return state.data.equipments.podsAndExtenders?.extraExtender || null;
        },
        extraPodsInCart (state) {
            // returns the number of extra pods in the cart
            return state.internetOptions.pods.quantity
        },
        isFiber (state, getters) {
            // returns true if the selected service is fiber, otherwise false
            return (getters.selectedService?.name?.indexOf('Fiber') > -1);
        },
        otherServices(state, getters, rootState, rootGetters) {
            let obj = { tv: null, voice: null}
            const cartData = rootState.Buyflow.receipt.cartData.services;

            // loop through the other services and get the name and price
            ['tv', 'voice'].forEach(type => {
                if (cartData[type].length) {
                    const service = cartData[type][0]
                    obj[type] = {
                        name: service.name,
                        price: rootGetters['Buyflow/' + type + '/getServicePrice']({price: service.promoPrice, priceDifference: service.promoPrice})
                    }
                }
            })
            return obj
        },
        isHidden (state, getters, rootState, rootGetters) {
            // returns true if the Internet section should be hidden, otherwise false
            return rootGetters['Buyflow/buyflowFeature']('buyflow_hide', 'internet')
        },
        isMinimal (state, getters, rootState, rootGetters) {
            // returns true if the Internet section should have minimal ui, otherwise false
            return rootGetters['Buyflow/buyflowFeature']('buyflow_minimal', 'internet')
        },
    },

    mutations: {
        UPDATE_INTERNET_OPTIONS (state, decision) {
            state.internetOptions = {...state.internetOptions, ...decision }
        },
    },

    actions: {
        init({ commit, state, rootState}) {
            // This is called from the main buyflow store initialize() method to initialize the Internet section selections
            const cartEquipment = rootState.Buyflow.receipt.cartData?.addOns?.internet?.equipment ?? []
            const cartInternet  = rootState.Buyflow.receipt.cartData?.services?.internet ?? []
            const cartExtraPods = rootState.Buyflow.receipt.cartData?.addOns?.internet?.extraExtender ?? []
            const equipments    = state.data?.equipments ?? []

            const equipmentName = cartEquipment?.length ?{ 'WiFi Your Way':'WiFi Your Way - 1 Pod', 'WiFi Your Way - WiFi 6 Extender': 'WYW OpenSync - WiFi 6 Extender' }[cartEquipment[cartEquipment.length - 1].name] || cartEquipment[cartEquipment.length - 1].name : null
            const service       = cartInternet?.length? Object.values(state.data?.services || {}).find(o => o.name === cartInternet[0].name): null
            const modem         = cartEquipment?.length? Object.values(equipments?.modemOptions || {}).find(o => o.name === cartEquipment[0]?.name): null
            const equipment     = equipmentName? Object.values(equipments?.wywOptions || {}).find(o => o.name === equipmentName): null
            const pods          = cartExtraPods?.length && equipments?.podsAndExtenders?.extraExtender?.name === cartExtraPods[0]?.name? {...equipments?.extraExtender, quantity: cartExtraPods[0]?.quantity }: null

            commit('UPDATE_INTERNET_OPTIONS', {
                service: {
                    decision: service?.decision ?? null,
                    selection: service ?? null
                },
                modem: {
                    decision: modem?.decision ?? null,
                    selection: modem ?? null
                },
                equipment: {
                    decision: equipment?.decision ?? null,
                    selection: equipment ?? null
                },
                pods: {
                    decision: pods?.decision ?? null,
                    selection: pods ?? null,
                    quantity: pods?.quantity ?? 0,
                },
            })
        },
        selectInternetOptions ({ dispatch, commit, state, getters, rootState }, payload) {
            // This call makes the Internet selections and updates the internetOptions state
            
            console.log('UPDATE_INTERNET_OPTIONS', payload)

            commit('UPDATE_INTERNET_OPTIONS', payload)

            if (payload.service?.selection) {
                const selectedService = payload.service.selection;
                
                // Filter labelRequest to only keep the selected service's label
                dispatch('BroadbandLabels/updateLabelRequest', selectedService.name, { root: true });
            }

            return dispatch('Buyflow/updateDecisions', payload, ROOT)
        },
    },
}
